module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "tochd"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Part1"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART ONE: THE SECRET WAR BEGINS")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter1"
    }
  }, [_vm._v("Chapter 1: Colby’s Covert War")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter2"
    }
  }, [_vm._v("Chapter 2: Switching Back—SOG Is Born")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter3"
    }
  }, [_vm._v("Chapter 3: Shining Brass")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART TWO: THE HO CHI MINH TRAIL")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Unfolding the Mysteries of the Trail")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART THREE: SOG’S AIR ARM")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Blackbirds and Night Skies")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Special Helicopters and Special Crews")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: FACs and Fighters")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART FOUR: RECON WEAPONS, MISSIONS, AND TACTICS")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Recon Equipment and Weapons")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Recon Missions")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: NVA Counterrecon Forces and Tactics")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Recon Tactics and Techniques")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Part5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART FIVE: RECON OPERATIONS")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Getting Teams In and Out")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: HALO: The Ultimate Infiltration Technique")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: The Recon Ethic")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Into Cambodia")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/28_Part6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART SIX: SOG’S HATCHET FORCES")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: Hatchet Force Operations")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Operation Tailwind")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Part7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PART SEVEN: OTHER FRONTS IN THE SECRET WARS")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Bright Light Rescues")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: The Greatest Raid of All")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: SOG in the Defense")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: SOG’s Darkest Programs")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0005-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147245f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 72
// module chunks = 0